import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-restrictedforbundle',
  templateUrl: './restrictedforbundle.component.html',
  styleUrls: ['./restrictedforbundle.component.scss']
})
export class RestrictedforbundleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
